const TABLEAU_SCRIPT_SRC = 'https://public.tableau.com/javascripts/api/viz_v1.js';

export default TABLEAU_SCRIPT_SRC
